import {useEffect} from "react";
import useCohortType from "../Stores/CohortStore";

interface CohortProps {
  displayValue: number;
  id?: string;
}

const CohortMenu: React.FC<CohortProps> = ({displayValue, id}) => {
  const cohortValue = useCohortType((state) => state.cohortValue);
  const setCohortValue = useCohortType((state) => state.setCohortValue);
  const disabledCohort = useCohortType((state) => state.disabledCohort);
  const cohortList = useCohortType((state) => state.cohortList);

  useEffect(() => {}, [displayValue]);

  return (
    <select
      id={id}
      className={`w-[50px] truncate lg:w-auto text-start xl:text-center xl:select xl:select-bordered text-[12px] bg-[#E5DCDD] appearance-none focus:outline-none focus:ring-0 focus:border-transparent ${
        disabledCohort ? "text-gray-400 opacity-60 cursor-not-allowed" : ""
      }`}
      defaultValue={cohortValue}
      onChange={(event) => setCohortValue(Number(event.target.value))}
      disabled={disabledCohort}>
      {cohortList.map((label, index) => (
        <option className="" key={index} value={index}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default CohortMenu;
